module.exports = __webpack_public_path__ + "1bad3c57d9286dc9926dfa65b7ab3920.svg";